import { type Reducer } from 'redux';

import { type setSPAutoSubmitSheet, ACTIONS } from '@~/actions/sp-state-actions';

interface SPInitialState {
  autoSubmitSheet: boolean;
}

type SPStateReducer = Reducer<SPInitialState, ReturnType<typeof setSPAutoSubmitSheet>>;

const initialState = {
  autoSubmitSheet: false,
};

const spStateReducer: SPStateReducer = (state = initialState, action) => {
  const { type, payload } = action;
  const { autoSubmitSheet } = payload || {};

  switch (type) {
    case ACTIONS.SET_SP_AUTO_SUBMIT_SHEET:
      return {
        ...state,
        autoSubmitSheet,
      };

    default:
      return state;
  }
};

export default spStateReducer;
